module.exports = __webpack_public_path__ + "static/media/client23.be695a3a.webp";